import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'
import { registerTendersHost, type TendersHost } from './host'
import { tendersModals } from './modals'

const List = lazy(() => import('./components/List'))
const BidResult = lazy(() => import('./components/BidResult'))
const Detail = lazy(() => import('./components/Detail'))

const TendersModule: RouteObject = {
    path: 'tenders',
    children: [
        {
            path: '',
            element: <List />,
        },
        {
            path: ':tenderId',
            element: <Detail />,
        },
        {
            path: ':tenderID/bid-result',
            element: <BidResult />,
        },
    ],
}

/**
 * The Tenders route, for the host to mount.
 *
 * This is the only way to get it, and it takes the host: so a host cannot mount
 * the route and forget to register the pieces it reads at render time.
 * Registering also adds the `tenders` i18n namespace and the module's modals.
 */
export function createTendersModule(host: TendersHost): RouteObject {
    registerTendersHost(host)
    host.registerModals(tendersModals)
    return TendersModule
}

export type { TendersHost } from './host'
